import React from 'react';
import { styles } from './styles';
import { withStyles, StyledComponentProps, Typography } from '@material-ui/core';
import { MenuPostNew } from '../../ui-components/Icons';

const comp = (props: StyledComponentProps) => {
    return (<div className={props.classes.root}>
        <MenuPostNew className={props.classes.subHeaderIcon} />
        <Typography className={props.classes.title} variant='h6'>Nuovo post</Typography>
    </div>)
}

export const NewPost = withStyles(styles)(comp)